import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { Subject, from } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';
import { Component, OnDestroy } from '@angular/core';

import { SnChannel, SnMessage } from '../../../../../communication/twiliochat/src/lib/models';
/* Need to import from file to avoid circular dependency */
import { SnChannelsService } from '../../../../../communication/twiliochat/src/lib/services/channels.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[sn-chat-toast]',
  templateUrl: './chat-toast.component.html',
  styleUrls: ['./chat-toast.component.scss'],
  animations: [
    trigger('flyInOut', [
      state(
        'inactive',
        style({
          opacity: 0,
        }),
      ),
      transition(
        'inactive => active',
        animate(
          '400ms ease-out',
          keyframes([
            style({
              transform: 'translate3d(100%, 0, 0) skewX(-30deg)',
              opacity: 0,
            }),
            style({
              transform: 'skewX(20deg)',
              opacity: 1,
            }),
            style({
              transform: 'skewX(-5deg)',
              opacity: 1,
            }),
            style({
              transform: 'none',
              opacity: 1,
            }),
          ]),
        ),
      ),
      transition(
        'active => removed',
        animate(
          '400ms ease-out',
          keyframes([
            style({
              opacity: 1,
            }),
            style({
              transform: 'translate3d(100%, 0, 0) skewX(30deg)',
              opacity: 0,
            }),
          ]),
        ),
      ),
    ]),
  ],
  preserveWhitespaces: false,
})
export class SnChatToastComponent extends Toast implements OnDestroy {
  public channel: SnChannel;
  public chatMessage: SnMessage;
  public toastCount: number = 1;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
    private readonly _channelsService: SnChannelsService,
  ) {
    super(toastrService, toastPackage);
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public popout(): void {
    if (this.channel.twilioChannel) {
      window.open(`/chat/${this.channel.twilioChannel.sid}`);
    }
  }

  public setSnooze(snoozeDuration: number): void {
    this._channelsService
      .updateChannelSettings(this.channel.id, { snoozeDuration })
      .pipe(takeUntil(this._destroy$))
      .subscribe(() => this.remove());
  }

  public getMediaSource(): void {
    from(this.chatMessage.twilio.media.getContentTemporaryUrl())
      .pipe(takeUntil(this._destroy$))
      .subscribe((source: string) => {
        this.chatMessage.mediaSource = source;
      });
  }
}
